// strv-standard: icons v1.0.0
// Master copy lives in strvcom/strv-it-hub /standard. Copy unchanged.
//
// One icon style for every tool: 24px grid, 2px stroke, square caps, mitred
// joins, no fills. Add new icons here (master) first, then copy.

const PATHS = {
  home: '<path d="M3 11 12 3l9 8"/><path d="M5 9v12h14V9"/><path d="M10 21v-6h4v6"/>',
  laptop: '<path d="M4 5h16v11H4z"/><path d="M2 19h20"/>',
  tag: '<path d="M3 3h8l10 10-8 8L3 11z"/><path d="M7 7h1v1H7z"/>',
  receipt: '<path d="M5 3h14v18l-2.5-1.5L14 21l-2-1.5-2 1.5-2.5-1.5L5 21z"/><path d="M9 8h6M9 12h6"/>',
  person: '<circle cx="12" cy="8" r="4"/><path d="M4 21v-3l4-4h8l4 4v3"/>',
  people: '<circle cx="9" cy="8" r="3.5"/><path d="M2 20v-2.5L5.5 14h7l3.5 3.5V20"/><path d="M15 4.5a3.5 3.5 0 0 1 0 7"/><path d="M18 14l4 3.5V20"/>',
  list: '<path d="M8 6h13M8 12h13M8 18h13M3 6h1M3 12h1M3 18h1"/>',
  shield: '<path d="M12 3l8 3v7l-8 8-8-8V6z"/>',
  key: '<circle cx="8" cy="15" r="4"/><path d="M11 12l9-9M16 7l3 3M14 9l2 2"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="M16.5 16.5 21 21"/>',
  sidebar: '<path d="M3 4h18v16H3z"/><path d="M9 4v16"/>',
  external: '<path d="M14 4h6v6"/><path d="M20 4l-9 9"/><path d="M18 14v6H4V6h6"/>',
  reload: '<path d="M20 12a8 8 0 1 1-2.34-5.66"/><path d="M20 4v5h-5"/>',
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>',
  moon: '<path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"/>',
  logout: '<path d="M10 4H4v16h6"/><path d="M16 8l4 4-4 4"/><path d="M20 12H9"/>',
  chevronRight: '<path d="M9 6l6 6-6 6"/>',
  arrowRight: '<path d="M4 12h15"/><path d="M13 6l6 6-6 6"/>',
  arrowDown: '<path d="M12 4v15"/><path d="M6 13l6 6 6-6"/>',
  chevronDown: '<path d="M6 9l6 6 6-6"/>',
  close: '<path d="M6 6l12 12M18 6 6 18"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  check: '<path d="M5 12l5 5 9-10"/>',
  alert: '<path d="M12 3 22 21H2z"/><path d="M12 10v5M12 18v.5"/>',
  chart: '<path d="M3 21h18"/><path d="M6 17v-6M11 17V5M16 17v-9M21 17v-3"/>',
  grid: '<path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z"/>',
  more: '<path d="M5 12h.5M12 12h.5M19 12h.5"/>',
};

/**
 * @param {keyof typeof PATHS} name
 * @param {{ size?: number, label?: string }} [opts] label → role="img", else hidden
 * @returns {string} SVG markup (trusted, ours)
 */
export function icon(name, { size = 18, label } = {}) {
  const body = PATHS[name] || PATHS.grid;
  const a11y = label ? `role="img" aria-label="${label.replace(/"/g, '')}"` : 'aria-hidden="true"';
  return `<svg ${a11y} width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter">${body}</svg>`;
}

export const ICONS = Object.keys(PATHS);
